<template>
  <div class="mt-8" v-show="showDetails">
    <dispute-notification v-if="documentDispute">
      {{ documentDispute.comment }}
    </dispute-notification>

    <div class="text-xs md:text-sm">
      <span class="text-gray-muted">We only allow JPG, PNG, GIF and PDF</span>
      <p class="font-medium text-input-text mb-2 mt-4">
        Proof of Business Address (Dated within the past three months)
      </p>
    </div>

    <div
      v-if="isDocumentSubmitted"
      class="w-full h-12 flex items-center justify-between px-2 rounded-lg border border-border-color text-gray-muted"
    >
      <span>
        {{ addressDoc.docSubtype }}
      </span>
      <el-tooltip content="Remove Document" placement="bottom">
        <span @click="handleRemoveDoc" class="cursor-pointer">
          <close-icon color="#5D5E68" />
        </span>
      </el-tooltip>
    </div>

    <input-file
      v-else
      @handleFileChange="handleChange"
      @handleRemove="handleRemoveFile"
      :id="id"
      :fileChoosen="fileChoosen"
      acceptedFiles=".jpg,.jpeg,.png,.pdf,.gif"
    />
    <button
      class="submitBtn self-center w-44 h-12 md:w-52 md:h-14 rounded-lg mt-8"
      :disabled="isDocumentSubmitted || isDocApproved || isLoading"
      @click="handleConfirm"
    >
      <spinner v-if="isLoading" size="small" />
      <span v-else>Confirm</span>
    </button>
  </div>
</template>

<script>
import kyc from '@/mixins/kyc.js'

export default {
  name: 'ProofOfAddress',
  mixins: [kyc],
  components: {
    InputFile: () => import('@/components/common/InputFile.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon2.vue'),
    DisputeNotification: () =>
      import('@/components/v2/completeKycForm/common/DisputeNotification.vue')
  },
  props: {
    upload: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isLoading: false,
      removeDoc: false,
      fileChoosen: false,
      formData: new FormData(),
      file: {},
      id: 'proofOfAddress'
    }
  },
  computed: {
    kycStep () {
      return this.isBusinessTypeHNI ? 5 : 7
    },
    showDetails () {
      if (this.isBusinessTypeHNI) {
        return this.upload.show && this.upload.step === 2
      } else {
        return this.upload.show && this.upload.step === 4
      }
    },
    addressDoc () {
      return (
        this.allDocuments.find(
          (doc) => doc.docSubtype === 'proof_of_address'
        ) || {}
      )
    },
    isDocumentSubmitted () {
      return (
        this.addressDoc.status === this.$STATUS.SUBMITTED && !this.removeDoc
      )
    }
  },
  methods: {
    handleConfirm () {
      if (this.file instanceof File) {
        this.formData.append('proof_of_address', this.file)

        const payload = {
          kycDetailsForm: this.formData,
          kycStep: this.kycStep,
          businessType: this.businessType
        }

        this.submitKycDetailsStepFormUpload(payload)
      }
    }
  }
}
</script>
